export default function handleChangeNumberInput(
  e: React.ChangeEvent<HTMLInputElement>,
  isFractional: boolean
) {
  if (isFractional) {
    const value = e.target.value
    let cleanedValue = value.replace(/[^0-9.]/g, '')
    const dotCount = cleanedValue.split('.').length - 1
    if (dotCount > 1) {
      cleanedValue = cleanedValue.replace(/\.+$/, '')
    }
    if (cleanedValue.startsWith('.')) {
      cleanedValue = '0' + cleanedValue
    }
    e.target.value = cleanedValue
  } else {
    const value = e.target.value
    const cleanedValue = value.replace(/[^0-9]/g, '')
    e.target.value = cleanedValue
  }
}
